import SubHeader from '../helpers/SubHeader.tsx';
import { NCard } from 'nayan';

const PrivacyPolicy = () => {
  return (
    <div className="p-3">
      <SubHeader title="Privacy Policy" />
      <NCard className="p-3 mt-3">
        <p className="mt-2">
          At <span className="font-semibold">Kidster</span>, the privacy and safety of our users—especially children—are of utmost importance to us.
          This Privacy Policy describes how we collect, use, store, and protect personal information in compliance with applicable laws and
          regulations, including the Children's Online Privacy Protection Act (COPPA), the General Data Protection Regulation (GDPR), and other
          relevant frameworks.
        </p>

        <h3 className="text-xl mt-6">1. Collection of Personal Data</h3>
        <p className="mt-2">
          We collect only the minimum personal data necessary for the secure operation of Kidster and to deliver our services. This data is collected
          lawfully, transparently, and with explicit parental or guardian consent where required. This may include:
        </p>
        <ul className="list-disc list-inside mt-2 ml-4">
          <li>Full name (child and/or parent)</li>
          <li>Email address of the parent or guardian</li>
          <li>Account credentials (such as username and encrypted password)</li>
          <li>Subscription status and transaction details</li>
        </ul>
        <p className="mt-2">
          This information is collected securely and exclusively used to manage user authentication, maintain subscription services, and ensure the
          appropriate experience for child users under supervision.
        </p>

        <h3 className="text-xl mt-6">2. Information We Do Not Collect</h3>
        <ul className="list-disc list-inside mt-2 ml-4">
          <li>We do not collect or store any location data.</li>
          <li>We do not track browsing behavior across other apps or websites.</li>
          <li>We do not collect device identifiers or other persistent data without consent.</li>
          <li>We do not use cookies for marketing or profiling purposes. Any use of cookies is strictly for authentication and security.</li>
        </ul>

        <h3 className="text-xl mt-6">3. Use of Data</h3>
        <p className="mt-2">We use personal data only for the following purposes:</p>
        <ul className="list-disc list-inside mt-2 ml-4">
          <li>Verifying account ownership and managing login sessions</li>
          <li>Tracking subscription status and handling billing via third-party processors</li>
          <li>Providing customer support to parents or guardians</li>
          <li>Ensuring compliance with age-appropriate content and legal requirements</li>
        </ul>

        <h3 className="text-xl mt-6">4. Third-Party Advertisements</h3>
        <p className="mt-2">
          The free version of Kidster may contain third-party advertisements. These advertisements may utilize limited anonymous identifiers to
          display relevant content. No personally identifiable data is shared with advertisers. Parents or guardians can remove all ads by purchasing
          a subscription.
        </p>

        <h3 className="text-xl mt-6">5. Subscription Services</h3>
        <p className="mt-2">
          Kidster offers a paid subscription to remove ads and unlock premium features. All payments are processed securely through third-party
          services compliant with PCI-DSS and other relevant security standards. We do not store or have access to any credit card or banking details.
        </p>

        <h3 className="text-xl mt-6">6. Data Retention</h3>
        <p className="mt-2">
          We retain personal data only for as long as necessary to fulfill the purpose for which it was collected or as required by law. Upon request
          by a parent or guardian, we will delete the associated account and all personal data from our servers.
        </p>

        <h3 className="text-xl mt-6">7. User Rights</h3>
        <p className="mt-2">Parents or guardians have the right to:</p>
        <ul className="list-disc list-inside mt-2 ml-4">
          <li>Review any personal data we have collected about their child</li>
          <li>Request deletion of their child’s account and associated data</li>
          <li>Withdraw consent at any time</li>
        </ul>
        <p className="mt-2">
          Requests can be made by contacting us at the email provided below. We will verify identity before taking action on such requests.
        </p>

        <h3 className="text-xl mt-6">8. Security Measures</h3>
        <p className="mt-2">
          We employ industry-standard security technologies and procedures to protect all collected data from unauthorized access, disclosure, or
          misuse. These include encryption of data in transit and at rest, strict access control, and regular security audits.
        </p>

        <h3 className="text-xl mt-6">9. Online Usage</h3>
        <p className="mt-2">
          Kidster requires an active internet connection to function. Offline access is limited and may restrict some features and content. Users are
          responsible for maintaining secure and private internet connections while using the app.
        </p>

        <h3 className="text-xl mt-6">10. Changes to This Privacy Policy</h3>
        <p className="mt-2">
          We reserve the right to update this Privacy Policy at any time. Changes will be posted with an updated effective date. Continued use of the
          app after changes are published constitutes acceptance of the revised policy.
        </p>

        <h3 className="text-xl mt-6">11. Contact Us</h3>
        <p className="mt-2">If you have any questions, requests, or concerns about this Privacy Policy or your child’s data, please contact us at:</p>
        <p className="mt-2">
          <span className="font-semibold">Email:</span> hello@inyter.com
        </p>

        <p className="mt-6">
          By using Kidster, you acknowledge that you have read, understood, and agreed to the terms outlined in this Privacy Policy.
        </p>
      </NCard>
    </div>
  );
};

export default PrivacyPolicy;
